import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "checkbox-unchecked-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.5 3.75C5.42921 3.75 3.75 5.42921 3.75 7.5V16.504C3.75 18.5728 5.42721 20.25 7.496 20.25H16.504C18.5729 20.25 20.25 18.5727 20.25 16.505V7.496C20.25 5.42721 18.5728 3.75 16.504 3.75H7.5ZM7.5 2.25H16.504C19.4012 2.25 21.75 4.59879 21.75 7.496V16.505C21.75 19.4013 19.4011 21.75 16.504 21.75H7.496C4.59879 21.75 2.25 19.4012 2.25 16.504V7.5C2.25 4.60079 4.60079 2.25 7.5 2.25Z"
    }, null, -1)
  ])))
}
export default { render: render }